module.exports = __webpack_public_path__ + "media/img/uploads/atak-mil-product-full-01-3c7d7d19efc9d3304a4b4609978e07e6.jpg";